import { Link } from "react-router";

import type { RaRecord } from "ra-core";
import { useTranslate } from "ra-core";
import { RelativeDate } from "../misc/RelativeDate";
import type { ActivityDealCreated } from "../types";
import { useActivityLogContext } from "./ActivityLogContext";

type ActivityLogDealCreatedProps = {
  activity: RaRecord & ActivityDealCreated;
};

export function ActivityLogDealCreated({
  activity,
}: ActivityLogDealCreatedProps) {
  const context = useActivityLogContext();
  const translate = useTranslate();
  const { deal } = activity;
  return (
    <div className="p-0">
      <div className="flex flex-row space-x-1 items-center w-full">
        <div className="w-5 h-5 bg-gray-300 rounded-full" />
        <div className="text-sm text-muted-foreground activity-log-container">
          <span className="activity-log-text">
            {translate("simplecrm.dashboard.activity.sales_id")}: {activity.sales_id}&nbsp;
            {translate("simplecrm.dashboard.activity.added_deal")}&nbsp;
            <Link to={`/deals/${deal.id}/show`}>{deal.name}</Link>
            {context !== "company" && (
              <>
                &nbsp;{translate("simplecrm.dashboard.activity.to_company")} {activity.company_id}&nbsp;
                <RelativeDate date={activity.date} />
              </>
            )}
          </span>
        </div>
        {context === "company" && (
          <span className="text-muted-foreground text-sm">
            <RelativeDate date={activity.date} />
          </span>
        )}
      </div>
    </div>
  );
}
